import { type StateCreator } from 'zustand/vanilla'
import { extendedTheme } from '#app/utils/extended-theme.ts'

type SectionData = {
	id: string
	backgroundColor: string
	intersectionRatio: number
}

export type UISlice = {
	backgroundColor: string
	changeBackgroundColor: (color: string) => void

	visibleSections: Map<string, SectionData>
	registerSection: (
		id: string,
		backgroundColor: string,
		intersectionRatio: number,
	) => void
	unregisterSection: (id: string) => void
}

export const createUISlice: StateCreator<UISlice, [], [], UISlice> = (
	set,
	get,
) => ({
	backgroundColor: extendedTheme.colors.background,
	changeBackgroundColor: (color: string) => {
		return set({
			backgroundColor: color,
		})
	},

	visibleSections: new Map<string, SectionData>(),
	registerSection: (
		id: string,
		backgroundColor: string,
		intersectionRatio: number,
	) => {
		set((state) => {
			const newSections = new Map(get().visibleSections)
			newSections.set(id, { id, backgroundColor, intersectionRatio })

			// Find the section with highest intersection ratio
			let maxRatio = 0
			let winningSection: SectionData | null = null

			for (const section of newSections.values()) {
				if (section.intersectionRatio > maxRatio) {
					maxRatio = section.intersectionRatio
					winningSection = section
				}
			}

			return {
				visibleSections: newSections,
				backgroundColor:
					winningSection?.backgroundColor || state.backgroundColor,
			}
		})
	},
	unregisterSection: (id: string) => {
		set((state) => {
			const newSections = new Map(state.visibleSections)
			newSections.delete(id)

			// Recalculate winner
			let maxRatio = 0
			let winningSection: SectionData | null = null

			for (const section of newSections.values()) {
				if (section.intersectionRatio > maxRatio) {
					maxRatio = section.intersectionRatio
					winningSection = section
				}
			}

			return {
				visibleSections: newSections,
				backgroundColor:
					winningSection?.backgroundColor || extendedTheme.colors.background,
			}
		})
	},
})
